import React, { ComponentType } from 'react'
import { Segment } from 'semantic-ui-react'

/**
 * Provides a component that renders the encounter practitioner
 * @param encounter Encounter entity
 * @param mode Render mode. Default: left
 */

const SafeSegment = Segment as unknown as ComponentType<any>

type Props = {
  encounter: any
  mode: string | undefined | null
}

function EncounterPractitioner(
  props: Props
) {
  const {
    encounter,
    mode = 'left'
  } = props
  if (mode !== 'left') return null
  return (
    <SafeSegment
      attached
      compact
      className="left-segment"
    >
      <div className="left-title">
        Practitioner:
      </div>
      <div className="left-content">
        <span>
          <span>
            { `${encounter.practitioner.firstName} ${encounter.practitioner.lastName}` }
          </span>
        </span>
      </div>
    </SafeSegment>
  )

}

export default EncounterPractitioner
